(function(){
  var root=document.querySelector('[data-snl-product]');
  if(!root) return;
  var cfg=JSON.parse(root.querySelector('[data-snl-config]').textContent);
  var variants=cfg.variants, optNames=cfg.options;

  function money(cents){
    var f=cfg.moneyFormat||'${{amount}}';
    function fmt(n,dec,th,d){n=(n/100).toFixed(dec);var p=n.split('.');p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,th);return p.join(d);}
    return f.replace(/\{\{\s*(\w+)\s*\}\}/,function(_,k){
      if(k==='amount_no_decimals')return fmt(cents,0,',','.');
      if(k==='amount_with_comma_separator')return fmt(cents,2,'.',',');
      if(k==='amount_no_decimals_with_comma_separator')return fmt(cents,0,'.',',');
      return fmt(cents,2,',','.');
    });
  }

  /* gallery */
  var track=root.querySelector('[data-snl-track]');
  var thumbs=[].slice.call(root.querySelectorAll('[data-snl-thumb]'));
  var dots=[].slice.call(root.querySelectorAll('[data-snl-dot]'));
  function setActive(i){thumbs.forEach(function(t,k){t.setAttribute('aria-current',k===i?'true':'false')});dots.forEach(function(d,k){d.classList.toggle('on',k===i)});}
  function goTo(i){if(!track)return;track.scrollTo({left:track.clientWidth*i,behavior:'smooth'});setActive(i);}
  thumbs.forEach(function(t,i){t.addEventListener('click',function(){goTo(i)})});
  if(track){track.addEventListener('scroll',function(){setActive(Math.round(track.scrollLeft/track.clientWidth))},{passive:true});}

  /* gallery videos: nothing downloads until the page has loaded and the slide is on screen */
  var vids=[].slice.call(root.querySelectorAll('.snl-slide video[data-src]'));
  if(vids.length){
    var saveData=navigator.connection&&navigator.connection.saveData;
    var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
    function start(v){
      if(!v.getAttribute('src')){v.src=(window.innerWidth<700&&v.getAttribute('data-src-sm'))||v.getAttribute('data-src');v.addEventListener('error',function(){var f=v.getAttribute('data-src');if(v.getAttribute('src')!==f){v.src=f;var q=v.play();if(q&&q.catch)q.catch(function(){});}},{once:true});v.addEventListener('playing',function(){v.parentNode.classList.add('playing')},{once:true});}
      var p=v.play();if(p&&p.catch)p.catch(function(){v.parentNode.classList.add('tap');});
    }
    function arm(){
      if(!('IntersectionObserver' in window)){start(vids[0]);return;}
      var io=new IntersectionObserver(function(es){es.forEach(function(e){
        var v=e.target;
        if(e.isIntersecting&&e.intersectionRatio>=.6){if(!saveData&&!reduce)start(v);}
        else if(!v.paused)v.pause();
      });},{threshold:[0,.6]});
      vids.forEach(function(v){io.observe(v);});
    }
    /* start as soon as the poster is painted (max 1.5 s), without waiting for third-party scripts */
    var armed=false;function go(){if(armed)return;armed=true;arm();}
    /* speed: wait for the page to finish loading, then start on first interaction or after 3.5 s idle */
    ['touchstart','scroll','pointerdown','keydown'].forEach(function(ev){window.addEventListener(ev,go,{once:true,passive:true});});
    /* no timer: the poster is shown until the shopper scrolls, swipes or taps */
    vids.forEach(function(v){v.addEventListener('click',function(){v.parentNode.classList.remove('tap');if(v.paused)start(v);else v.pause();});v.addEventListener('playing',function(){v.parentNode.classList.remove('tap');});});
  }

  /* variants */
  var selected=cfg.current.options.slice();
  var idInput=root.querySelector('[data-snl-id]');
  var priceNow=root.querySelector('[data-snl-now]'), priceWas=root.querySelector('[data-snl-was]'), off=root.querySelector('[data-snl-off]');
  var stock=root.querySelector('[data-snl-stock]'), atcs=[].slice.call(document.querySelectorAll('[data-snl-atc]'));
  var stickyP=document.querySelector('[data-snl-sticky-price]');
  function find(){for(var i=0;i<variants.length;i++){var v=variants[i],ok=true;for(var j=0;j<selected.length;j++){if(v.options[j]!==selected[j]){ok=false;break;}}if(ok)return v;}return null;}
  function esc(x){return String(x).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
  function shipDay(){var n=nowTz(),today=new Date(Date.UTC(n.y,n.m,n.d)),tom=new Date(today);tom.setUTCDate(tom.getUTCDate()+1);var s=addBiz(today,1);return s.getTime()===tom.getTime()?'tomorrow':s.toLocaleDateString(cfg.locale,{weekday:'long',timeZone:'UTC'});}
  function describe(v){return v.options.map(function(val,i){return /size|taille/i.test(optNames[i]||'')?'size '+val:val}).join(', ');}
  var lastMedia;
  function update(){
    var v=find();
    [].forEach.call(root.querySelectorAll('[data-snl-opt]'),function(group){
      var idx=+group.getAttribute('data-snl-opt');
      var lab=group.querySelector('[data-snl-optlabel]'); if(lab)lab.textContent=selected[idx];
      [].forEach.call(group.querySelectorAll('[data-value]'),function(b){
        b.setAttribute('aria-pressed',b.getAttribute('data-value')===selected[idx]?'true':'false');
        var test=selected.slice(); test[idx]=b.getAttribute('data-value');
        var match=variants.filter(function(x){return x.options.every(function(o,k){return o===test[k]})})[0];
        b.classList.toggle('soldout',!match||!match.available);
        b.classList.toggle('low',!!match&&match.available&&match.managed&&match.qty>0&&match.qty<=cfg.stockThreshold);
        var pr=b.querySelector('.pr');if(pr){pr.textContent=match?money(match.price):'';pr.dataset.p=match?match.price:'';}
      });
      var prs=[].map.call(group.querySelectorAll('.pr'),function(x){return x.dataset.p});
      var differ=prs.some(function(x){return x&&x!==prs[0]});
      [].forEach.call(group.querySelectorAll('.pr'),function(x){x.hidden=!differ});
    });
    if(!v){atcs.forEach(function(a){a.disabled=true;a.textContent=cfg.t.unavailable});if(stock)stock.hidden=true;return;}
    idInput.value=v.id;
    priceNow.textContent=money(v.price);
    if(stickyP)stickyP.textContent=money(v.price);
    if(v.compare>v.price){priceWas.textContent=money(v.compare);priceWas.hidden=false;off.textContent='−'+Math.round((1-v.price/v.compare)*100)+'%';off.hidden=false;}
    else{priceWas.hidden=true;off.hidden=true;}
    atcs.forEach(function(a){
      a.disabled=!v.available;
      a.textContent=v.available?(a.hasAttribute('data-snl-short')?cfg.t.add:cfg.t.add+' — '+money(v.price)):cfg.t.soldout;
    });
    if(stock){
      var st=stock.querySelector('[data-snl-stock-t]'),sb=stock.querySelector('[data-snl-stock-bar]');
      var low=v.managed&&v.available&&v.qty>0&&v.qty<=cfg.stockThreshold;
      if(low){
        st.innerHTML=cfg.t.only.replace('[n]','<b>'+v.qty+' left</b>').replace('[variant]',esc(describe(v)));
        if(sb){sb.hidden=false;sb.firstChild.style.width=Math.max(6,Math.round(v.qty/(cfg.stockThreshold*4)*100))+'%';}
        stock.classList.add('is-low');stock.hidden=false;
      }else if(v.available&&cfg.t.instock){
        st.textContent=cfg.t.instock.replace('[day]',shipDay());
        if(sb)sb.hidden=true;stock.classList.remove('is-low');stock.hidden=false;
      }else stock.hidden=true;
    }
    var swb=root.querySelector('.is-sw [aria-pressed="true"][data-media]'),tm=swb?+swb.getAttribute('data-media'):v.media;
    if(tm!=null&&tm!==lastMedia){if(lastMedia!==undefined){var pos=cfg.mediaPositions.indexOf(tm);if(pos>-1)goTo(pos);}lastMedia=tm;}
    if(history.replaceState){var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u);}
  }
  [].forEach.call(root.querySelectorAll('[data-snl-opt]'),function(group){
    var idx=+group.getAttribute('data-snl-opt');
    [].forEach.call(group.querySelectorAll('[data-value]'),function(b){
      b.addEventListener('click',function(){selected[idx]=b.getAttribute('data-value');update();});
    });
  });
  update();

  /* add to cart */
  var err=root.querySelector('[data-snl-err]');
  atcs.forEach(function(a){a.addEventListener('click',function(e){
    e.preventDefault(); if(a.disabled)return;
    a.disabled=true; if(err)err.hidden=true;
    var R=(window.Shopify&&Shopify.routes?Shopify.routes.root:'/');
    function fail(j){a.disabled=false;if(err){err.textContent=(j&&(j.description||j.message))||cfg.t.error;err.hidden=false;}}
    function json(r){return r.json().then(function(j){if(!r.ok)throw j;return j;});}
    var drawer=document.querySelector('cart-drawer');
    if(drawer&&drawer.dataset.sectionId){
      /* theme cart drawer: add, re-render drawer (theme auto-gift adds the mystery gift), open */
      var secs=[drawer.dataset.sectionId]; if(document.querySelector('.auto-gifts'))secs.push('auto-gifts');
      fetch(R+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:+idInput.value,quantity:1}],sections:secs.join(',')})})
        .then(json)
        .then(function(j){
          var ev=new Event('cart:updated',{bubbles:true});ev.detail={resource:{},data:{source:'snl-pdp',sections:j.sections}};
          document.dispatchEvent(ev);
          a.disabled=false;if(typeof drawer.open==='function')drawer.open();
        })
        .catch(fail);
      return;
    }
    (cfg.gift?fetch(R+'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){return c.items.some(function(i){return i.variant_id===cfg.gift})}).catch(function(){return true}):Promise.resolve(true))
      .then(function(has){var items=[{id:+idInput.value,quantity:1}];if(!has)items.push({id:cfg.gift,quantity:1});
        return fetch(R+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
          .then(function(r){if(r.ok||has)return r;return fetch(R+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[items[0]]})});});})
      .then(json)
      .then(function(){location.href=R+'cart';})
      .catch(fail);
  });});

  /* shipping cutoff: order before midnight (store tz) -> ships next business day */
  var cut=root.querySelector('[data-snl-cut]'), eta=root.querySelector('[data-snl-eta]');
  function nowTz(){var p=new Intl.DateTimeFormat('en-US',{timeZone:cfg.tz,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'}).formatToParts(new Date()),o={};p.forEach(function(x){o[x.type]=x.value});return {y:+o.year,m:+o.month-1,d:+o.day,h:+o.hour,mi:+o.minute,s:+o.second};}
  function isBiz(d){var w=d.getUTCDay();return w!==0&&w!==6;}
  function addBiz(d,n){var r=new Date(d);while(n>0){r.setUTCDate(r.getUTCDate()+1);if(isBiz(r))n--;}return r;}
  function long(d){return d.toLocaleDateString(cfg.locale,{weekday:'long',month:'short',day:'numeric',timeZone:'UTC'});}
  function short(d){return d.toLocaleDateString(cfg.locale,{month:'short',day:'numeric',timeZone:'UTC'});}
  function tick(){
    if(!cut)return;
    var n=nowTz(),today=new Date(Date.UTC(n.y,n.m,n.d)),tom=new Date(today);tom.setUTCDate(tom.getUTCDate()+1);
    var ship=addBiz(today,1),late=addBiz(tom,1);
    var left=86400-(n.h*3600+n.mi*60+n.s),h=Math.floor(left/3600),m=Math.floor(left%3600/60);
    if(ship.getTime()!==late.getTime()) cut.innerHTML=cfg.t.within.replace('[time]','<span>'+h+'h '+String(m).padStart(2,'0')+'m</span>').replace('[date]',long(ship));
    else cut.textContent=cfg.t.today.replace('[date]',long(ship));
    if(eta)eta.textContent=cfg.t.eta.replace('[from]',short(addBiz(ship,cfg.etaMin))).replace('[to]',short(addBiz(ship,cfg.etaMax)));
  }
  tick(); setInterval(tick,30000);

  /* sticky ATC */
  var sticky=document.querySelector('[data-snl-sticky]'), mainAtc=root.querySelector('[data-snl-atc]');
  if(sticky&&mainAtc&&'IntersectionObserver' in window){
    new IntersectionObserver(function(e){sticky.classList.toggle('on',!e[0].isIntersecting&&e[0].boundingClientRect.top<0);}).observe(mainAtc);
  }

  /* size guide drawer */
  var drawer=document.querySelector('[data-snl-drawer]');
  [].forEach.call(document.querySelectorAll('[data-snl-sg]'),function(b){b.addEventListener('click',function(){if(drawer)drawer.hidden=false;});});
  if(drawer){
    drawer.addEventListener('click',function(e){if(e.target===drawer||e.target.hasAttribute('data-snl-close'))drawer.hidden=true;});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')drawer.hidden=true;});
  }
})();
